import Axios from "axios";
import * as CONSTANTS from "../classes/constants";
import { Session } from "../classes/Session";
import { SessionConfig } from "../classes/SessionConfig";

const ENDPOINT = "/api/cirt";

export function getNetwork(session) {
  return session.getRoleView("admin");
}

export async function getInfo(session) {
  let response = await Axios.get(ENDPOINT + `/playerInfo/${session.sessionConfig.getSessionId()}`)
  let info = session.getAdditionalInfo();
  for (let roleName in info.roles) {
    info.roles[roleName] = {...info.roles[roleName], ...response.data.roles[roleName]}
  }
  return info;
}

export function advanceRound(session) {
  return `round advanced to round ${session.beginNextRound()}`
}

export function getNetworkView(session, role) {
  if (role === "admin") {
    return getNetwork(session);
  }
  return session.getRoleView(role);
}

export function investigate(session, name, role) {
  return session.investigateNode(role, name);
}

export function shutoff(session, name, role) {
  return session.shutoffNode(role, name);
}

export function notify(session, name, role) {
  if (role === CONSTANTS.PIO) {
    return session.evaluateNotifyAction(name, role);
  }
  else {
    throw new Error("Only PIO can notify");
  }
}

export function isolate(session, name, role) {
  return session.isolateNode(role, name);
}
export async function beginGame(sessionId, playTestConfig) {
  if (!playTestConfig) {
    throw new Error("playTestConfig is required");
  }
  if (!('seed' in playTestConfig)) {
    throw new Error("seed attribute required");
  }
  let gameSeed = playTestConfig.seed;
  if (!('rounds' in playTestConfig)) {
    throw new Error("rounds attribute required");
  }
  let rounds = playTestConfig.rounds;
  if (!('round_duration' in playTestConfig)) {
    throw new Error("round_duration attribute required");
  }
  let roundDuration = playTestConfig.round_duration;
  if (!('break_duration' in playTestConfig)) {
    throw new Error("break_duration attribute required");
  }
  let breakDuration = playTestConfig.break_duration;
  if (!('round_attacks' in playTestConfig)) {
    throw new Error("round_attacks attribute required");
  }
  let roundAttacks = playTestConfig.round_attacks

  if (!parseInt(rounds)) {
    throw new Error("rounds value not valid");
  }

  let gameDebug = ('debug' in playTestConfig) ? playTestConfig.debug : false;
  let gameDrill = ('drill' in playTestConfig) ? playTestConfig.drill : false;
  let gameForce = ('force' in playTestConfig) ? playTestConfig.force : false;

  if (!typeof gameDebug == "boolean") {
    throw new Error("debug must be a true or false");
  }
  let config = SessionConfig.build(gameDrill, rounds, gameSeed, roundDuration, breakDuration, gameDebug, sessionId, roundAttacks)

  return await Session.build(config);
}

export function makeRoleReady(session, role) {
  return session.makeRoleReady(role);
}

export function forceGameStart(session) {
  session.forceGameStart();
}

export function getGroupSettings(group) {
  return Axios.post(ENDPOINT + `/getGroupSettings`, {
    params: {
      group
    }
  });
}

export function getCirtModuleContent() {
  return Axios.post(ENDPOINT + `/getCirtModuleContent`, {
    params: {
      pcs: localStorage.getItem('pcs')
    }
  });
}

export function saveSessionToDb(groupId, session) {
  return Axios.post('/api/cirt/saveToDb', {
    params: {
        groupId: groupId,
        session: session
    }
})
}